import { useModal } from '@gluedigital/modal';
import { FormattedMessage } from 'react-intl';

import './ShareChatButton.sass';

const ShareChatButton = ({ disabled }: { disabled: boolean }) => {
	const modal = useModal();
	const handleShare = () => modal.show('share-modal', { message: null, replyTo: null });
	return (
		<button disabled={disabled} className="share-chat-button" onClick={handleShare}>
			<span className="icon icon-share" />
			<span>
				<FormattedMessage id="share-chat" />
			</span>
		</button>
	);
};

export default ShareChatButton;
